module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/c330e2593ab03e21c33bc910035b3afb.png";